<template>
  <div class="rui-field" :class="componentCSS">
    <label v-if="label" :for="inputId" :class="{'-sr-only': invisibleLabel}">{{ label }}</label>
    <div class="rui-field__field">
      <slot />
      <div v-if="append" class="rui-field__field__append">{{ append }}</div>
    </div>
    <div v-if="help || $slots.help" class="rui-field__help">
      <!-- @slot Custom help content -->
      <slot name="help">{{ help }}</slot>
    </div>
    <template v-if="errors.length > 0">
      <div v-for="(message, index) in errors" :key="index" class="rui-field__error">{{ message }}</div>
    </template>
  </div>
</template>

<script>
/**
 * Label, input help text and errors
 *
 * @preset Default {
 *                   "props" : { "label": "Address" },
 *                   "slots" : {
 *                     "default": "<input type=\"text\" />"
 *                   }
 *                 }
 * @propsGroup Label   [inputId, invisibleLabel]
 * @propsGroup Display [inline]
 * @propsGroup Content [label, append, help, error]
 */
export default {
  name: 'RuiField',
  props: {
    /** Input ID for the label reference */
    inputId: { required: false, type: String, default: null },
    /** Label content */
    label: { required: false, type: String, default: null },
    /** Text to append next to the slot */
    append: { required: false, type: String, default: null },
    /** Help text */
    help: { required: false, type: String, default: null },
    /** Error text, if any */
    error: { required: false, type: [String, Array], default: null },
    /** Style the slot content for an inline display (i.e.: border radius,...) */
    inline: { required: false, type: Boolean, default: false },
    /** Whether to make the label visible for screen readers only */
    invisibleLabel: { required: false, type: Boolean, default: false },
  },
  computed: {
    errors () {
      if (!this.error) return []

      return Array.isArray(this.error) ? this.error : [this.error]
    },
    componentCSS () {
      return [
        this.inline && 'rui-field--inline',
      ]
    },
  },
}
</script>
